export default __webpack_public_path__ + "static/media/unlock.c45f33f8.svg";